import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

type Props = {
  icon?: object;
  children: any;
  center?: boolean;
  largeIcon?: boolean;
};

function CardLayout({ icon, children, center, largeIcon }: Props) {
  return (
    <Container largeIcon={largeIcon}>
      <IconWrapper>{icon}</IconWrapper>
      <Content center={center}>{children}</Content>
    </Container>
  );
}

export default CardLayout;

const IconWrapper = styled('div')`
  align-items: center;
  display: flex;
`;
const Content = styled('div')<Props>`
  align-items: center;
  display: flex;
  ${(props: Props) =>
    props.center &&
    css`
      justify-content: center;
      padding-right: 40px;
    `};
`;

const Container = styled('div')<Props>`
  width: 100%;
  display: grid;
  padding: 16px;
  grid-gap: 16px;
  grid-template-columns: ${(props: Props) => (props.largeIcon ? '40px 1fr' : '32px 1fr')};
  margin: auto 0;
`;
